import React from 'react'
import styles from './blogContent.module.css'


function BlogContent() {
    return (
        <div className={styles.main}>            
            Blog is coming soon...
        </div>
    )
}
export default BlogContent